import React from "react";
import { Message } from "../../../components";

export const NoLinkedAccounts = ({color}) => (
  <Message severity="warning-or-significant" bg="yellow.t10" color={color}>
   Please return to cart and select an alternative payment method.
  </Message>
);
